import { AlertManager } from 'react-alert'
import { LoginPayload } from 'services'
import { StyleProps, Constraints } from '@touche-lts/panel-ui/dist'

export interface LoginPageProps extends StyleProps {
  alert: AlertManager
}

export enum Tabs {
  LOGIN = 'Log in',
  REGISTER = 'Register'
}

export const loginFormConstraints: Constraints<LoginPayload> = {
  emailAddress: {
    presence: true,
    format: {
      // eslint-disable-next-line max-len
      pattern: /^[a-z0-9][a-z0-9-_.]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/i
    }
  },
  password: {
    presence: true,
    length: {
      minimum: 2
    }
  },
  reCaptchaToken: {
    presence: true,
    length: {
      minimum: 2
    }
  }
}
